import React from "react";
import { useTranslation } from "react-i18next";

interface SimpleContentStepProps {
    text: string;
    fw?: string;
}

const SimpleContentStep: React.FC<SimpleContentStepProps> = ({ text, fw = "normal" }) => {
    const { t } = useTranslation();
    return <span className={`d-inline-block fs-7 fw-${fw}`}>{t(text)}</span>;
};

export default SimpleContentStep;
